





















import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * Components
 */
import SummaryPage from "./components/SummaryPage.vue";

/**
 * Utils
 */
import { getLocaleDateString } from "@/utils/date-helpers";
import { getFullName } from "@/utils/users-helpers";
import { sortByAsc } from "@/utils/sort-helpers";

/**
 * Mixins
 */
import mixinsAPI from "@/mixins/api-mixins";

/**
 * API
 */
import bookingsAPI, { BookingCategory } from "@/api/bookings";

/**
 * Types
 */
import { Cart } from './store';

/**
 * Page de détail d'une réservation effectuée Click & Collect.
 */
@Component({
	components: { SummaryPage },
	mixins: [mixinsAPI]
})
export default class BookingShopDetailsPage extends Vue {
	/** Injections */
	getLocaleDateString = getLocaleDateString;
	getFullName = getFullName;

	/** VueX - Snackbar */
	@Action('openInfo', { namespace: 'snackbar' })
	openInfo: any;
	@Action('openError', { namespace: 'snackbar' })
	openError: any;

	/** Attributs */
	isLoading = false;

	dateBooking: Date | null = null;
	dateBooked: Date | null = null;
	serviceBooked: any | null = null;
	userBooked: any | null = null;
	cart: Cart = new Cart();

	get breadcrumbItems() {
		return [
			{
				text: this.$t('menu.booking_shop'),
				disabled: false,
				append: false,
				exact: true,
				to: '/booking_shop'
			},
			{
				text: this.$t('booking_shop.details'),
				disabled: true,
			}
		];
	}

	/** Méthodes */
	async created() {
		const params = this.$route.params as any;
		const bookingId = params.id as number;
		this.isLoading = true;
		try {
			const bookingDetails = await bookingsAPI.getOne(bookingId);
			this.cart = Object.assign(new Cart(), bookingDetails.cartDetails);
			this.dateBooking = new Date(bookingDetails.bookingDate);
			this.dateBooked = new Date(bookingDetails.bookedDate);
			this.serviceBooked = bookingDetails.service;
			this.userBooked = bookingDetails.user;
		}
		catch (err) {
			this.$router.push('/');
			(this as any).handleAPIError(err);
		}

		this.isLoading = false;
	}

}
